module.exports = __webpack_public_path__ + "img/custom.32ea0982.png";